import { render, staticRenderFns } from "./OnboardingSuccessQr.vue?vue&type=template&id=77897354&"
import script from "./OnboardingSuccessQr.ts?vue&type=script&lang=ts&"
export * from "./OnboardingSuccessQr.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports